/* eslint-disable angular/controller-name */

angular.
module("dx.webapp.masterTools").
controller("DxBulkChangeEmailRouteController", function BulkChangeEmailRouteController(
	$http,

	validationService,

	ngPasteFromErrors
) {
	"use strict";

	var self = this;

	self.emails = [];
	self.error = null;
	self.isChangingEmails = false;
	self.hasChangedEmails = false;
	self.hasValidated = false;
	self.filteredEmails = [];
	self.filteredEmailErrors = [];

	self.onBeforePaste = function onBeforePaste(data) {
		self.error = null;
		self.hasChangedEmails = false;
		self.hasValidated = false;

		return data;
	};

	self.onValidateEntry = function onValidateEntry(row) {
		var fromIsValid = validationService.isEmailValid(row.fromEmail.trim());
		if (!fromIsValid) {
			self.error = "Current e-mail is not valid: " + row.fromEmail.trim();
		}

		var toIsValid = validationService.isEmailValid(row.toEmail.trim());
		if (!toIsValid) {
			self.error = "New e-mail is not valid: " + row.toEmail.trim();
		}

		return fromIsValid && toIsValid;
	};

	self.onEntryError = function onEntryError(error, rowData) {
		if (error === ngPasteFromErrors.invalidColumnLength) {
			self.error = "Expected column length to be " + rowData.expectedLength;
		}
	};

	self.bulkChangeEmail = function bulkChangeEmail(execute) {
		self.isChangingEmails = true;
		self.hasValidated = false;

		var url = "/mastertools/bulkchangeemail?execute=" + (execute ? "true" : "false");

		$http.post(url, {emails: self.emails}).then(onBulkChangeEmailSuccess, onBulkChangeEmailError);

		function onBulkChangeEmailSuccess(response) {
			if (execute) {
				self.hasChangedEmails = true;
			} else {
				self.hasValidated = true;
				self.filteredEmails = response.data.invalid.emails;
				self.filteredEmailErrors = response.data.errors;
				self.emails = response.data.valid.emails;
			}
			self.isChangingEmails = false;
		}

		function onBulkChangeEmailError(response) {
			if (response.data.msgs !== null && response.data.msgs.length > 0) {
				self.error = response.data.msgs;
			} else {
				self.error = response.data;
			}

			self.isChangingEmails = false;
		}
	};

	self.checkValidChanges = function checkValidChanges() {
		//Returns false if self.emails is nil else returns self.email.length > 0
		if (self.emails !== null) {
			return self.emails.length > 0;
		}
		return false;
	};
});
